import axios from 'axios';
import {req, exportExcel} from './axiosFun';

/**
 * 开放平台文档中心
 **/
//文档开发中心-获取文档分组列表数据
export const indexGroupList = () => {
  return req("get", "/api/common/doc/groupList")
};
//文档开发中心-获取文档栏目列表数据
export const indexSortList = (groupId) => {
  return req("get", "/api/common/doc/sortList?groupId=" + groupId)
};
//文档开发中心-获取文档列表数据
export const indexDocList = (params) => {
  return req("get", "/api/common/doc/docList?groupId=" + params.groupId + '&sortId=' + params.sortId+ '&status=' + params.status + '&isRecommend=' + params.isRecommend)
};
//文档开发中心-查询文档列表数据
export const indexGetById = (id) => {
  return req("get", "/api/common/doc/getById?id=" + id)
};
// 文档开发中心-通过关键字查询文档列表数据
export const docSearchList = (params) => {
  return req("get", "/api/common/doc/list?searchKey=" + params.searchKey +'&pageSize='+params.pageSize+'&pageNo='+params.pageNo)
};
/**
 * 首页
 **/
// 首页
export const indexData = (params) => {
  return req("post", "/api/auth/index/data", params)
};
// 账号管理-列表
export const userList = (params) => {
  return req("post", "/api/auth/seller/user/list", params)
};
/**
 * 文档管理
 **/
// 获取文档分组列表数据-列表
export const docGroupList = (params) => {
  return req("get", "/api/auth/docgroup/list?groupName=" + params.groupName + '&status=' + params.status+'&pageSize='+params.pageSize+'&pageNo='+params.pageNo)
};
// 文档分组-新增
export const docGroupAdd = (params) => {
  return req("post", "/api/auth/docgroup/add", params)
};
// 文档分组-修改
export const docGroupUpdate = (params) => {
  return req("post", "/api/auth/docgroup/edit", params)
};
// 文档分组-详情
export const docGroupDetail = (id) => {
  return req("get", "/api/auth/docgroup/query?id=" + id)
};
// 获取文档分组列表数据-列表
export const docSortList = (id) => {
  return req("get", "/api/auth/docsort/list?groupId=" +id +'&pageSize=100'+'&pageNo=1')
};
// 文档分组-新增
export const docSortAdd = (params) => {
  return req("post", "/api/auth/docsort/add", params)
};
// 文档分组-修改
export const docSortUpdate = (params) => {
  return req("post", "/api/auth/docsort/edit", params)
};
// 文档分组-删除
export const docSortDelete = (params) => {
  return req("put", "/api/auth/docsort/delete", params)
};
// 开发文档管理-列表
export const docList = (params) => {
  return req("get", "/api/auth/doc/list?groupName=" + params.groupName + '&sortName=' + params.sortName+ '&docName=' + params.docName+ '&isFree=' + params.isFree+ '&isLimit=' + params.isLimit + '&status=' + params.status+'&pageSize='+params.pageSize+'&pageNo='+params.pageNo)
};
// 开发文档管理-新增
export const docAdd = (params) => {
  return req("post", "/api/auth/doc/add", params)
};
// 开发文档管理-修改
export const docUpdate = (params) => {
  return req("post", "/api/auth/doc/edit", params)
};
// 开发文档管理-详情
export const docDetail = (id) => {
  return req("get", "/api/auth/doc/query?id=" + id)
};
// 开发文档管理-详情
export const docListPubParam = () => {
  return req("get", "/api/auth/doc/listPubParam")
};
// 开发文档管理-问答-新增
export const docAddQa = (params) => {
  return req("post", "/api/auth/doc/addQa", params)
};
// 开发文档管理-问答-修改
export const docUpdateQa = (params) => {
  return req("post", "/api/auth/doc/editQa", params)
};
// 开发文档管理-问答-详情
export const docListQaDetail = (id) => {
  return req("get", "/api/auth/doc/listQa?docId=" + id)
};
// 开发文档管理-问答-删除
export const docListQaDelete = (params) => {
  return req("put", "/api/auth/doc/deleteQa", params)
};
// 开发文档管理-错误码-新增
export const docAddErrorCode = (params) => {
  return req("post", "/api/auth/doc/addErrorCode", params)
};
// 开发文档管理-错误码-修改
export const docUpdateErrorCode = (params) => {
  return req("post", "/api/auth/doc/editErrorCode", params)
};
// 开发文档管理-错误码-详情
export const docListErrorCode = (id) => {
  return req("get", "/api/auth/doc/listErrorCode?docId=" + id)
};
// 开发文档管理-错误码-删除
export const docErrorCodeDelete = (params) => {
  return req("put", "/api/auth/doc/deleteErrorCode", params)
};
// 开发文档管理-请求参数-新增
export const docAddReqParam = (params) => {
  return req("post", "/api/auth/doc/addReqParam", params)
};
// 开发文档管理-请求参数-修改
export const docUpdateReqParam = (params) => {
  return req("post", "/api/auth/doc/editReqParam", params)
};
// 开发文档管理-请求参数-详情
export const docListReqParam = (id) => {
  return req("get", "/api/auth/doc/listReqParam?docId=" + id)
};
// 开发文档管理-请求参数-删除
export const docReqParamDelete = (params) => {
  return req("put", "/api/auth/doc/deleteReqParam", params)
};
// 开发文档管理-响应参数-新增
export const docAddResParam = (params) => {
  return req("post", "/api/auth/doc/addResParam", params)
};
// 开发文档管理-响应参数-修改
export const docUpdateResParam = (params) => {
  return req("post", "/api/auth/doc/editResParam", params)
};
// 开发文档管理-响应参数-详情
export const docListResParam = (id) => {
  return req("get", "/api/auth/doc/listResParam?docId=" + id)
};
// 开发文档管理-响应参数-删除
export const docResParamDelete = (params) => {
  return req("put", "/api/auth/doc/deleteResParam", params)
};
// 开发文档管理-生成响应示例
export const docInitRespInst = (params) => {
  return req("put", "/api/auth/doc/initRespInst", params)
};
// 开发文档管理-发布-取消发布文档
export const docRelease = (params) => {
  return req("put", "/api/auth/doc/release", params)
};

/**
 * 角色管理
 */
// 新增角色
export const roleAdd = (params) => {
  return req("post", "/api/auth/role/add", params)
};
// 修改角色
export const roleEdit = (params) => {
  return req("post", "/api/auth/role/edit", params)
};
// 给角色分配权限
export const roleAssignPermissions = (params) => {
  return req("post", "/api/auth/role/assignPermissions", params)
};
// 获取角色管理列表数据
export const roleList = (params) => {
  return req("get", "/api/auth/role/list?pageSize=" + params.pageSize + '&pageNo=' + params.pageNo + '&roleName=' + params.roleName + '&status=' + params.status)
};
// 获取当前用户角色权限
export const roleGetPermissionListByUser = (params) => {
  return req("get", "/api/auth/role/getPermissionListByUser", params)
};
// 获取角色可配置权限树
export const roleRolePermissionTree = (id) => {
  return req("get", "/api/auth/role/rolePermissionTree?RoleId=" + id)
};




// WEBPACK FOOTER //
// ./src/api/basisMG.js